
import {useReducer} from 'react';

export type State = {
	open: boolean
	overlay: boolean
	report: string
};

export type Handlers = {
	toggleOpen: () => void
	toggleOverlay: () => void
	onReport: (report: string) => void
}

type Action =
  | { type: 'TOGGLE-OPEN' }
  | { type: 'TOGGLE-OVERLAY' }
  | { type: 'REPORT', report: string }
;

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
	case 'TOGGLE-OPEN':
		return {
			open: !state.open,
			overlay: false,
			report: '',
		};

	case 'TOGGLE-OVERLAY':
		return {
			open: true,
			overlay: !state.overlay,
			report: state.report,
		};

	case 'REPORT':
		return {
			open: true,
			overlay: state.overlay,
			report: action.report,
		};
	}
};

export const useState = () => {
	const [state, dispatch] = useReducer(reducer, {
		open: false,
		overlay: false,
		report: '',
	});

	return {
		state,
		toggleOpen: () => dispatch({type: 'TOGGLE-OPEN'}),
		toggleOverlay: () => dispatch({type: 'TOGGLE-OVERLAY'}),
		onReport: (report: string) => dispatch({type: 'REPORT', report}),
	};
};
